document.addEventListener("DOMContentLoaded", function () {
  const productCards = document.querySelectorAll(".card-row-wrapper");
  const updateFunctions = [];

  productCards.forEach(function (card) {
    const quantityInput = card.querySelector(".quantity__input");
    const packInfo = card.querySelector(".pricingQty");
    const areaInfo = card.querySelector(".areaCovered");
    const priceContainer = card.querySelector(".priceSelected");
    const plusButton = card.querySelector(".quantity__button--plus");
    const minusButton = card.querySelector(".quantity__button--minus");

    if (!quantityInput || !packInfo) return;

    const metersPerPack = parseFloat(card.getAttribute("data-meters-per-pack"));
    const selectedPrice = parseFloat(card.getAttribute("data-card-price"));

    const updatePackInfo = () => {
      const quantity = parseInt(quantityInput.value) || 0;
      const totalMeters = (quantity * metersPerPack).toFixed(2);
      const totalPrice = (quantity * selectedPrice) / 100;

      const vatCurrent = sessionStorage.getItem("vatToggle");
      const includeVAT = vatCurrent === "true";
      const displayPrice = includeVAT ? totalPrice : totalPrice / 1.2;

      priceContainer.textContent = `£${displayPrice.toFixed(2)}`;
      packInfo.textContent = `${quantity} Pack${quantity !== 1 ? 's' : ''}`;

      if (areaInfo) {
        areaInfo.textContent = `${totalMeters}m² covered`;
      }
    };
    updatePackInfo();

    updateFunctions.push(updatePackInfo);

    quantityInput.addEventListener("input", updatePackInfo);
    if (plusButton) {
      plusButton.addEventListener("click", () => {
        setTimeout(updatePackInfo, 50);
      });
    }
    if (minusButton) {
      minusButton.addEventListener("click", () => {
        setTimeout(updatePackInfo, 50);
      });
    }
  });

  // Expose VAT-triggered update globally
  window.updateAllCardPrices = function () {
    updateFunctions.forEach(fn => fn());
  };
});
